import { Box, Chip } from '@mui/material'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FaRobot } from 'react-icons/fa'
import { FormattedMessage } from 'react-intl'

import { EN } from 'constants/general'

export const AutoTranslatePill = () => {
    const { locale } = useRouter()

    if (locale === EN) {
        return <Box />
    }

    return (
        <Box sx={styles.container}>
            <Link href="/autotranslate">
                <Chip
                    icon={<FaRobot size={'24px'} />}
                    label={
                        <FormattedMessage
                            defaultMessage="Automatic translation"
                            description="Automatic translation from English indicator"
                        />
                    }
                    sx={styles.chip}
                />
            </Link>
        </Box>
    )
}

const styles = {
    container: {
        alignItems: 'center',
        display: 'flex',
    },
    chip: {
        backgroundColor: '#f0f0f0',
        marginLeft: '12px',
        color: '#666',
        '& .MuiChip-icon': {
            color: '#666',
            marginLeft: '12px',
            marginRight: '-4px',
            position: 'static',
            height: '24px',
            width: '24px',
        },
        height: 'auto',
        borderRadius: '8px',
        '& .MuiChip-label': {
            display: 'block',
            padding: '8px 12px',
        },
        fontSize: '14px',
    },
}
